import { Card, CardContent, TableContainer } from '@mui/material';

/**
 * Standard white card wrapping a data table.
 */
export default function DataTableCard({ children, sx, contentSx, tableSx }) {
  return (
    <Card sx={{ overflow: 'hidden', ...sx }}>
      <CardContent
        sx={{
          p: 0,
          '&:last-child': { pb: 0 },
          ...contentSx
        }}
      >
        <TableContainer sx={{ overflowX: 'auto', ...tableSx }}>{children}</TableContainer>
      </CardContent>
    </Card>
  );
}
